import React, { useEffect } from 'react';
import clsx from 'clsx';
import DraggableColorList from './DraggableColorList';
import { ValidatorForm } from 'react-material-ui-form-validator';
import arrayMove from 'array-move';
import PaletteFormNav from './PaletteFormNav';
import useStyles from './styles/NewPaletteFormStyles';
import PaletteFromDrawer from './PaletteFormDrawer';

export default function NewPaletteForm(props) {
   const defaultColors = [
      { name: 'red', color: '#F44336' },
      { name: 'pink', color: '#E91E63' },
      { name: 'purple', color: '#9C27B0' },
      { name: 'deeppurple', color: '#673AB7' },
      { name: 'indigo', color: '#3F51B5' },
      { name: 'blue', color: '#2196F3' },
      { name: 'lightblue', color: '#03A9F4' },
      { name: 'cyan', color: '#00BCD4' },
      { name: 'teal', color: '#009688' },
      { name: 'green', color: '#4CAF50' },
      { name: 'lightgreen', color: '#8BC34A' },
      { name: 'lime', color: '#CDDC39' },
      { name: 'yellow', color: '#FFEB3B' },
      { name: 'amber', color: '#FFC107' },
      { name: 'orange', color: '#FF9800' },
      { name: 'deeporange', color: '#FF5722' },
      { name: 'brown', color: '#795548' },
      { name: 'grey', color: '#9E9E9E' },
      { name: 'bluegrey', color: '#607D8B' },
      { name: 'reddish', color: '#D92B2B' }
   ];
   const classes = useStyles();
   const windowMobile = window.innerWidth <= 575.98;
   const [open, setOpen] = React.useState(!windowMobile);
   const [actualColor, setActualColor] = React.useState('#03a2ec');
   const [emoji, setEmoji] = React.useState('🤙');
   const [colors, setColors] = React.useState(defaultColors.slice(0, -1));
   const [newName, setNewName] = React.useState('');
   const [newPaletteName, setNewPaletteName] = React.useState('');

   useEffect(() => {
      document.documentElement.style.setProperty('--overflowStyles', 'hidden');
   }, []);

   useEffect(() => {
      ValidatorForm.addValidationRule('isColorNameUnique', value =>
         colors.every(color => color.name.toLowerCase() !== value.toLowerCase())
      );

      ValidatorForm.addValidationRule('isColorUnique', () =>
         colors.every(color => color.color !== actualColor)
      );

      ValidatorForm.addValidationRule('isPaletteNameUnique', () =>
         props.palettes.every(
            palette =>
               palette.paletteName.toLowerCase() !==
               newPaletteName.toLowerCase()
         )
      );
   });

   function handleDrawerOpen() {
      setOpen(true);
   }

   function handleDrawerClose() {
      setOpen(false);
   }

   function handleColorChange(e) {
      setActualColor(e.hex);
   }

   function createColors() {
      const newColor = { color: actualColor, name: newName };

      setColors([...colors, newColor]);
      setActualColor('#446688');
      setNewName('');
   }

   function handleNewName(e) {
      setNewName(e.target.value);
   }
   function handleNewPaletteName(e) {
      setNewPaletteName(e.target.value);
   }

   function removeColor(name) {
      setColors([...colors.filter(color => color.name !== name)]);
   }

   function handleEmoji(emoji) {
      setEmoji(emoji.native);
   }

   function savePalette() {
      const newPalette = {
         paletteName: newPaletteName,
         id: newPaletteName.toLowerCase().replace(/ /g, '-'),
         emoji,
         colors
      };

      props.savePalette(newPalette);

      setTimeout(() => {
         props.history.push('/');
      }, 100);
   }

   const onSortEnd = ({ oldIndex, newIndex }) => {
      const oldColors = colors;
      setColors([...arrayMove(oldColors, oldIndex, newIndex)]);
   };

   const clearColors = () => {
      setColors([]);
   };

   const randomColor = () => {
      const allColors = props.palettes.map(p => p.colors).flat();
      let randomNumber;
      let randomColor;
      let isDuplicateColor = true;

      while (isDuplicateColor) {
         randomNumber = ~~(Math.random() * allColors.length);
         randomColor = allColors[randomNumber];
         // eslint-disable-next-line
         isDuplicateColor = colors.some(
            // eslint-disable-next-line
            color => color.name === randomColor.name
         );
      }

      setColors([...colors, randomColor]);
   };

   const disabledButtons = colors.length === props.maxColors ? true : false;

   return (
      <div className={classes.root}>
         <PaletteFormNav
            classes={classes}
            handleDrawerOpen={handleDrawerOpen}
            savePalette={savePalette}
            newPaletteName={newPaletteName}
            handleNewPaletteName={handleNewPaletteName}
            history={props.history}
            open={open}
            handleEmoji={handleEmoji}
         />

         <PaletteFromDrawer
            classes={classes}
            open={open}
            handleDrawerClose={handleDrawerClose}
            clearColors={clearColors}
            randomColor={randomColor}
            disabledButtons={disabledButtons}
            handleColorChange={handleColorChange}
            actualColor={actualColor}
            createColors={createColors}
            newName={newName}
            handleNewName={handleNewName}
         />

         <main
            className={clsx(classes.content, {
               [classes.contentShift]: open
            })}
         >
            <div className={classes.drawerHeader} />

            <DraggableColorList
               colors={colors}
               removeColor={removeColor}
               axis="xy"
               onSortEnd={onSortEnd}
               distance={10}
            />
         </main>
      </div>
   );
}
